import React from 'react';
import { Clock, ListChecks, Wallet, ShieldCheck, BadgePercent } from 'lucide-react';
import FadeIn from './FadeIn';

const benefits = [
  {
    icon: Clock,
    title: 'Save Time',
    description: 'No more weekend store visits. Reclaim your hours.',
  },
  {
    icon: ListChecks,
    title: 'Save Effort',
    description: 'We manage and organize your entire grocery list.',
  },
  {
    icon: Wallet,
    title: 'Wholesale Prices Always',
    description: 'No need to worry about prices — you always pay wholesale rates, never retail markups.',
  },
  {
    icon: ShieldCheck,
    title: 'Great Quality, Always',
    description: 'Every product is handpicked from trusted vendors — freshness and quality guaranteed.',
  },
  {
    icon: BadgePercent,
    title: 'Special Discounts',
    description: 'Enjoy exclusive deals and special discounts on products every month.',
  },
];

export default function WhyUs() {
  return (
    <section id="why-us" className="section-spacing">
      <div className="content-width-wide">
        <FadeIn>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground tracking-tight text-center">
            Built For Busy Households
          </h2>
        </FadeIn>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {benefits.map(({ icon: Icon, title, description }, i) => (
            <FadeIn key={i} delay={i * 0.1}>
              <div className="flex items-start gap-4 p-6 bg-white rounded-2xl border border-border hover:border-primary/20 hover:shadow-md transition-all duration-300">
                <span className="flex items-center justify-center h-12 w-12 rounded-xl bg-secondary flex-shrink-0">
                  <Icon className="h-5 w-5 text-primary" strokeWidth={1.5} />
                </span>
                <div>
                  <h3 className="font-heading text-lg font-semibold text-foreground">{title}</h3>
                  <p className="mt-1 text-muted-foreground leading-relaxed">{description}</p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
